var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "import-status",
    class: _vm.containerClass
  }, [_c('span', {
    staticClass: "import-status__icon-container"
  }, [_c('icon', {
    attrs: {
      "name": _vm.iconName
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "import-status__text"
  }, [_vm._v("\n    " + _vm._s(_vm.translatedStatus) + _vm._s(_vm.maybeErrorCount) + "\n  ")])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e97cca1c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ImportStatus.vue
// module id = 2132
// module chunks = 0